import React, { HTMLAttributes } from "react";
import cx from "classnames";
import Dialog from "component/atoms/ModalDialog/index";
import SVGIcons from "assets/icon";

import "./MessageBox.styl";

const dialogStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    /// 아래 스타일은 stylus로 커스텀 되게 수정하자
    backgroundcolor: "#3c3c3c"
  }
};

enum ButtonType {
  MB_OK = "OK",
  MB_YESNO = "YESNO",
  MB_CLOSE = "CLOSE"
}

/**
 * @description MessageBox UI Component Properties
 *
 * @interface IMessageBoxProps
 * @extends {HTMLAttributes<HTMLDivElement>}
 */
interface IMessageBoxProps extends HTMLAttributes<HTMLDivElement> {
  open: boolean;
  title?: string;
  message?: string;
  hasCloseButton?: boolean;
  hasTodayOffButton?: boolean;
  buttonType?: ButtonType;
  onClose?: Function;
  onYes?: Function;
  onNo?: Function;
}

interface IMessageBoxState {
  open: boolean;
}

/**
 *
 */
/**
 * @todo CSS 정리하기
 *
 * @class MessageBox
 * @extends {React.PureComponent<IMessageBoxProps, IMessageBoxState>}
 */
class MessageBox extends React.Component<IMessageBoxProps, IMessageBoxState> {
  private dialogPrefix: string = "message-box";

  static defaultProps = {
    onClose: null,
    onYes: null,
    onNo: null
  };
  constructor(props: any) {
    super(props);
    this.state = {
      open: props.open
    };
  }
  componentWillReceiveProps = (nextProps: any) => {
    (this.state.open as any) = nextProps.open;
  };
  shouldComponentUpdate(nextProps: any, nextState: any) {
    // if (nextProps.open === true) {
    //   return true;
    // }
    // return false;
    const vitalPropsChange = this.props.open !== nextProps.open;
    const vitalStateChange = this.state.open !== nextState.open;
    return vitalPropsChange || vitalStateChange;
  }
  closeModal = () => {
    this.setState({ open: false });
    const { onClose } = this.props;

    if (onClose !== null && onClose !== undefined) {
      onClose();
    }
  };

  handleYesClick = () => {
    this.closeModal();

    // if (!this.refs.todayOffCheckbox) {
    //   const isTodayOff = this.refs.todayOffCheckbox;
    //   if ((isTodayOff as any).checked) {
    //     Helper.Cookie.closeWinAt00("TodayMessageBoxOff", 1);
    //   }
    // }

    const { onYes } = this.props;
    if (onYes) {
      onYes();
    }
  };

  handleNoClick = () => {
    this.closeModal();
    const { onNo } = this.props;
    if (onNo) {
      onNo();
    }
  };

  renderButton = () => {
    const { buttonType } = this.props;
    let buttonRenderer = () => {
      return null;
    };

    if (buttonType === ButtonType.MB_OK) {
      (buttonRenderer as any) = this.renderOkButton;
    } else if (buttonType === ButtonType.MB_YESNO) {
      (buttonRenderer as any) = this.renderYesNoButton;
    } else if (buttonType === ButtonType.MB_CLOSE) {
      (buttonRenderer as any) = this.renderCloseButton;
    } else {
      throw Error("Invalid messagebox button type");
    }

    return buttonRenderer();
  };

  renderCloseButton = () => {
    return (
      <React.Fragment>
        <button className="btn message-box-btn" onClick={this.closeModal}>
          Close
        </button>
      </React.Fragment>
    );
  };

  renderOkButton = () => {
    return (
      <React.Fragment>
        <button className="btn message-box-btn" onClick={this.closeModal}>
          Ok
        </button>
      </React.Fragment>
    );
  };

  renderYesNoButton = () => {
    return (
      <React.Fragment>
        <button className="btn message-box-btn" onClick={this.handleYesClick}>
          Yes
        </button>
        <button className="btn message-box-btn" onClick={this.handleNoClick}>
          No
        </button>
      </React.Fragment>
    );
  };

  renderTodayOffButton = () => {
    //const { hasTodayOffButton } = this.props;
    // if (hasTodayOffButton) {
    //   return (
    //     <React.Fragment>
    //       <input
    //         className="text-right"
    //         type="checkbox"
    //         name="todayOffCheckbox"
    //         value="off"
    //         ref="todayOffCheckbox"
    //       />
    //       오늘 하루 보지 않기
    //     </React.Fragment>
    //   );
    // }
    return;
  };

  render() {
    const { message, hasCloseButton } = this.props;
    const contentClassName = "message-box-content";
    const backgroundClassName = "message-box-background";
    return (
      <Dialog.ModalPortal
        isOpen={this.state.open}
        onRequestClose={this.closeModal}
        className={cx(contentClassName, "noselect", "nodrag")}
        backgroundClassName={backgroundClassName}
        style={dialogStyles}
      >
        <Dialog.DialogLayout.DialogHeader
          inlist=""
          dialogPrefix={this.dialogPrefix}
          closeButton={hasCloseButton}
          onRequestClose={this.closeModal}
        >
          <Dialog.DialogLayout.DialogTitle
            inlist=""
            dialogPrefix={this.dialogPrefix}
            className="h4 text-center" // Text-center:Bootstrap
          >
            <SVGIcons.SVGWarningIcon />
          </Dialog.DialogLayout.DialogTitle>
        </Dialog.DialogLayout.DialogHeader>
        <Dialog.DialogLayout.DialogBody
          inlist=""
          dialogPrefix={this.dialogPrefix}
          className="text-center"
        >
          <p>
            {message &&
              message.split("\n").map((line, index) => {
                return (
                  <span key={index}>
                    {line}
                    <br />
                  </span>
                );
              })}
          </p>
        </Dialog.DialogLayout.DialogBody>
        <Dialog.DialogLayout.DialogFooter
          inlist=""
          dialogPrefix={this.dialogPrefix}
          className="text-center"
        >
          {this.renderButton()}
          {this.renderTodayOffButton()}
        </Dialog.DialogLayout.DialogFooter>
      </Dialog.ModalPortal>
    );
  }
}

export default MessageBox;
